import styled from "styled-components";

import { Tooltip } from "@similarweb/ui-components";

export const StyledTooltip = styled(Tooltip)`
    && {
        box-sizing: border-box;
        max-width: 230px;
    }
`;
